import React from 'react';
import classnames from 'classnames';
import Link from 'next/link';
import { ConBrandWebV1ListResponse } from '@/services/swagger/data-contracts';
import LogoWithText from '@/business-components/LogoWithText';
import styles from './index.module.scss';

export type BrandCardProps = {
  className?: string;
} & ConBrandWebV1ListResponse;

const BrandCard: React.FC<BrandCardProps> = ({
  conBrandId,
  chName,
  ehName,
  companyChName,
  companyEhName,
  logoUrl,
  industryTrackName,
  oneLevelTrackName,
  // twoLevelTrackName,
  companyCity,
  financeRoundsName,
  // compositeScore,
  // rankingRateInIndustry,
  className,
}) => {
  return (
    <Link href={`/brand/${conBrandId}`}>
      <a className={classnames(styles.card, className)} target="_blank">
        <div className={styles.basicInfo}>
          <LogoWithText
            src={logoUrl}
            width={50}
            borderRadios={10}
            chName={chName}
            ehName={ehName}
            spanClass={styles.logoSpan}
          />
          <div className={styles.nameContainer}>
            <span className={styles.chName}>{chName || ehName}</span>
            <span className={styles.enName}>{chName ? ehName : ''}</span>
            <span className={styles.fullName}>{companyChName || companyEhName}</span>
          </div>
        </div>
        <div className={styles.splitLine}></div>
        <div className={styles.detailInfo}>
          <div className={styles.infoRow}>
            <span className={styles.infoName}>所属行业</span>
            <span className={styles.infoValue}>{industryTrackName || '-'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoName}>所属赛道</span>
            <span className={styles.infoValue}>
              {/* {oneLevelTrackName}/{twoLevelTrackName} */}
              {oneLevelTrackName || '-'}
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoName}>所属地区</span>
            <span className={styles.infoValue}>{companyCity || '-'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoName}>融资轮次</span>
            <span className={styles.infoValue}>{financeRoundsName || '-'}</span>
          </div>
        </div>
        {/*<div className={styles.dataInfo}>*/}
        {/*  <div className={styles.scoreContainer}>*/}
        {/*    <span className={styles.dataInfoValue}>{compositeScore?.toFixed(2)}</span>*/}
        {/*    <span className={styles.dataInfoName}>综合指数</span>*/}
        {/*  </div>*/}
        {/*  <div className={styles.rankingContainer}>*/}
        {/*    <div>*/}
        {/*      <span className={styles.rankingText}>前</span>*/}
        {/*      <span className={styles.dataInfoValue}>{rankingRateInIndustry}%</span>*/}
        {/*    </div>*/}
        {/*    <span className={styles.dataInfoName}>行业排名</span>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </a>
    </Link>
  );
};

export default BrandCard;
